import {Button, CardHeader, Divider, Grid, MenuItem, Pagination, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';

export class StrategicLayoutToolMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            ruby: {
                data: [],
                total: 0,
                limit: 10,
                offset: 0,
            },
            competitive: {
                data: [],
                total: 0,
                limit: 10,
                offset: 0,
            },
        }
    }

    componentDidMount() {
        this.fetchData("ruby");
        this.fetchData("competitive");
    }

    fetchStrategicLayouts = () => axios.get(`${Config.getInstance.apiUrl}/api/tools/get-duplicated-strategic-layouts?limit=10&offset=0`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        },
    });

    fetchCompetitiveLayouts = () => axios.get(`${Config.getInstance.apiUrl}/api/tools/get-duplicated-strategic-competition-layouts?limit=10&offset=0`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        },
    });

    removeLayout = async (layout: any, mode: "ruby" | "competitive") => {
        if (confirm("Are you sure you want to remove this layout?")) {
            try {
                const path = mode === "ruby" ? "remove-duplicated-strategic-layout" : "remove-duplicated-strategic-competition-layout";
                const response = await axios.post(`${Config.getInstance.apiUrl}/api/tools/${path}`, {
                    user_id: layout.user_id,
                }, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                        env: this.props.activeEnv,
                    },
                });
                if (response.data.success) {
                    PopupMessage.success("Layout removed!");
                    this.setState({
                        [mode]: {
                            ...this.state[mode],
                            data: {
                                ...this.state[mode]?.data,
                                data: (this.state[mode]?.data?.data || []).filter((item: any) => item.user_id !== layout.user_id),
                            }
                        },
                        total: (this.state[mode]?.total - 1),
                        limit: (this.state[mode]?.limit || 0),
                        offset: (this.state[mode]?.offset || 0),
                    });
                } else {
                    PopupMessage.error("Layout remove failed: " + response.data.message);
                }
            } catch (error) {
                console.error("removeLayout error", error);
                PopupMessage.error("Layout remove failed: " + error.message);
            }
        }
    }

    removeAllDuplicatedLayouts = async () => {
        if (confirm("Are you sure you want to remove all duplicated layouts?")) {
            try {
                this.setState({
                    loading: true,
                });
                const response = await axios.post(`${Config.getInstance.apiUrl}/api/tools/remove-all-duplicated-strategic-layouts`, {}, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                        env: this.props.activeEnv,
                    },
                });
                if (response.data.success) {
                    PopupMessage.success("All duplicated layouts removed!");
                    this.setState({
                        loading: false,
                        ruby: {
                            data: [],
                            total: 0,
                            limit: 10,
                            offset: 0,
                        },
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                    PopupMessage.error("All duplicated layouts remove failed: " + response.data.message);
                }
            } catch (error) {
                console.error("removeAllDuplicatedLayouts error", error);
                PopupMessage.error("All duplicated layouts remove failed: " + error.message);
                this.setState({
                    loading: false,
                });
            }
        }
    }

    fetchData = async (mode: "ruby" | "competitive") => {
        this.setState({
            loading: true,
        });

        if (mode === "ruby") {
            const strategicLayoutsResponse = await this.fetchStrategicLayouts();
            const slData = strategicLayoutsResponse?.data;
            console.log("strategicLayouts", slData);
            this.setState({
                loading: false,
                ruby: {
                    data: slData,
                    total: slData?.pagination?.total,
                    limit: slData?.pagination?.limit,
                    offset: slData?.pagination?.offset,
                },
            });
        }
        if (mode === "competitive") {
            const competitiveLayoutsResponse = await this.fetchCompetitiveLayouts();
            const clData = competitiveLayoutsResponse?.data;
            console.log("competitiveLayouts", clData);
            this.setState({
                loading: false,
                competitive: {
                    data: clData,
                    total: clData?.pagination?.total,
                    limit: clData?.pagination?.limit,
                    offset: clData?.pagination?.offset,
                },
            });
        }
    }

    changePage(page: number, mode: "ruby" | "competitive") {
        const {limit} = this.state[mode] || {};
        const newOffset = (page - 1) * Number(limit);
        this.setState({
            [mode]: {
                ...this.state[mode],
                offset: newOffset,
            },
        });
        this.fetchData(mode);
    }

    renderPagination(mode: "ruby" | "competitive") {
        const {total, limit, offset} = this.state[mode];
        const totalPages = Math.ceil(Number(total) / Number(limit));

        return <Pagination
            count={totalPages}
            page={Number(offset) / Number(limit) + 1}
            onChange={(e, page) => this.changePage(page, mode)}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
            style={{marginTop: "20px", display: "ruby"}}
        />
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    renderLayout = (mode: "ruby" | "competitive") => {
        const { data } = this.state[mode] || {};
        
        const layouts = data?.data || [];
        if (!layouts || !layouts?.length) {
            return <Paper>
                <Typography style={{textAlign: 'center', width: "100%"}}>No data found</Typography>
            </Paper>
        }
        return <Paper>
             <Table className="max-table-size">
                <TableHead>
                    <TableRow>
                        <TableCell style={{width: "5%"}}>#</TableCell>
                        <TableCell style={{width: "5%"}}>User Id</TableCell>
                        <TableCell style={{width: "5%"}}>Layout Count</TableCell>
                        <TableCell style={{width: "5%"}}>Layout Ids</TableCell>
                        <TableCell style={{width: "30%"}} align="center">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        layouts.map((item: any, index: number) => {
                            const userId = item.user_id;
                            const layoutCount = item.layout_count;
                            const layoutIds = item.layout_ids.join("; ");
                            return <TableRow key={item.user_id}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{userId}</TableCell>
                                <TableCell>{layoutCount}</TableCell>
                                <TableCell>
                                    <ContentCopyIcon
                                        titleAccess="Copy Layout IDs"
                                        onClick={() => this.copyToClipboard(layoutIds)}
                                    />
                                    <div style={{width: '300px', overflowX: 'auto', whiteSpace: 'nowrap'}}>
                                        <Typography>{layoutIds}</Typography>
                                    </div>
                                </TableCell>
                                <TableCell align="center">
                                    <DeleteIcon
                                        style={{color: "red"}}
                                        titleAccess="Remove Duplicated Layout"
                                        onClick={() => this.removeLayout(item, mode)}
                                    />
                                    <Typography style={{color: "red"}}>Remove Duplicated</Typography>
                                </TableCell>
                            </TableRow>
                        })
                    }
                    <TableRow>
                        <TableCell colSpan={20} style={{textAlign: 'center', width: "100%"}}>
                            {this.renderPagination(mode)}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    }


    renderContent() {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        // const boobyTrapsData = this.state.boobyTrapsData;
        const {classes} = this.props;

        return <>
            <Typography className={classes.paper} variant="h6">{`Duplicated Strategic Layouts: ${this.state.ruby.total} users`}</Typography>
            {this.renderLayout("ruby")}

            <Divider style={{marginTop: 50, marginBottom: 50}} />
            <Typography variant="h6" className={classes.paper}>{`Duplicated Competitive Layouts: ${this.state.competitive.total} users`}</Typography>
            {this.renderLayout("competitive")}
        </>
    }

    render() {
        const {classes} = this.props;
        return <Paper>
            <Typography className={classes.paper} variant="h6">{`Booby Traps Layouts Tool`}</Typography>
            <Divider style={{marginTop: 10, marginBottom: 10}} />
            <Button variant="contained" color="primary" onClick={this.removeAllDuplicatedLayouts}>Remove all duplicated Layout</Button>
            <Divider style={{marginTop: 10, marginBottom: 10}} />
            {this.renderContent()}
        </Paper>
    }
}

const styles: any = () => ({
    paper: {
        padding: 8,
        backgroundColor: "black"
    },
});

export const StrategicLayoutTool = withStyles(styles)(StrategicLayoutToolMain);